import { useRouteTrailer } from '../../hooks/use-route-trailer';
import { DetailedCellProps } from '../hooks/use-columns';

const TrailerCell = ({ row: route }: DetailedCellProps) => {
	const { trailerName } = useRouteTrailer(route);

	return <>{trailerName}</>;
};

export default TrailerCell;
